package one.healthium.ui.compose.components

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun AppSeparator(
    modifier: Modifier = Modifier,
    text: String,
) {
    Text(
        modifier = modifier.padding(start = 4.dp, top = 18.dp, end = 4.dp),
        text = text,
        style = AppTheme.textStyles.section,
        color = AppTheme.colors.text400,
    )
}